import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { BASE_PATH_API } from "../../utils/Constants";
import { ProgressSpinner } from "primereact/progressspinner";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";

interface RemoteFile {
  name: string;
  type: "file" | "directory";
}

interface FileExplorerProps {
  ordenCompra: number;
  ano: string;
  mes: string;
}

const ShowFilesRepo: React.FC<FileExplorerProps> = ({
  ordenCompra,
  ano,
  mes,
}) => {
  const [files, setFiles] = useState<RemoteFile[]>([]);
  const [selectedFileUrl, setSelectedFileUrl] = useState<string | null>(null);
  const [isListModalOpen, setIsListModalOpen] = useState<boolean>(false);
  const [isViewerOpen, setIsViewerOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // 1. Cargar lista de archivos
  const loadFiles = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${BASE_PATH_API}/files/api/list/${ordenCompra}?ano=${ano}&mes=${mes}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        },
      );
      if (!response.ok) throw new Error("Error al conectar con el servidor");

      const data: RemoteFile[] = await response.json();
      setFiles(data);
      setIsListModalOpen(true);
    } catch (error) {
      console.error("Error:", error);
      alert("No se pudo cargar la lista de archivos.");
    } finally {
      setIsLoading(false);
    }
  };

  // 2. Preparar archivo para ver en el segundo modal
  /*const openViewer = (fileName: string) => {
    const fullUrl = `${BASE_PATH_API}/files/api/filevisual/${fileName}?ano=${ano}&mes=${mes}&orden=${ordenCompra}`;

    if (
      fileName.toLowerCase().endsWith(".xlsx") ||
      fileName.toLowerCase().endsWith(".xls")
    ) {
      const googleViewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(fullUrl)}&embedded=true`;
      setSelectedFileUrl(googleViewerUrl);
    } else {
      setSelectedFileUrl(fullUrl);
    }
    setIsViewerOpen(true);
  };
*/

  const openViewer = (fileName: string) => {
    const fullUrl = `${BASE_PATH_API}/files/api/filevisual/${fileName}?ano=${ano}&mes=${mes}&orden=${ordenCompra}`;
    setSelectedFileUrl(fullUrl);
    setIsViewerOpen(true);
  };

  return (
    <div className="p-2">
      <Button
        style={{ marginLeft: "15px", height: "40px", padding: "10px" }}
        label={isLoading ? "Cargando..." : "Ver Archivos"}
        icon={isLoading ? "pi pi-spin pi-spinner" : "pi pi-folder-open"}
        onClick={loadFiles}
        className="p-button-outlined p-button-success"
        disabled={isLoading}
      />

      {/* MODAL 1: LISTADO DE ARCHIVOS */}
      <Dialog
        header={`Archivos: Orden ${ordenCompra}`}
        visible={isListModalOpen}
        style={{ width: "50vw" }}
        onHide={() => setIsListModalOpen(false)}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      >
        <div className="flex flex-column gap-2 mt-2">
          {files.length > 0 ? (
            files.map((file, idx) => (
              <div
                key={idx}
                className="flex align-items-center justify-between p-3 border-round border-1 border-200 hover:surface-100 transition-colors"
              >
                <div className="flex align-items-center gap-3">
                  <i className="pi pi-file-pdf text-red-500 text-xl"></i>
                  <span className="font-medium text-700">{file.name}</span>
                </div>
                <Button
                  icon="pi pi-eye"
                  label="Visualizar"
                  className="p-button-text p-button-sm"
                  onClick={() => openViewer(file.name)}
                />
              </div>
            ))
          ) : (
            <div className="text-center p-4 text-500 italic">
              No se encontraron archivos en este repositorio.
            </div>
          )}
        </div>
      </Dialog>

      {/* MODAL 2: VISOR CENTRADO (Encima del anterior) */}
      <Dialog
        header={
          selectedFileUrl?.split("/").pop()?.split("?")[0] || "Visor de Archivo"
        }
        headerStyle={{ margin: "auto", width: "95% !important" }}
        visible={isViewerOpen}
        // Change 1: Set to full viewport dimensions
        style={{ width: "100vw", height: "100vh", fontSize: "0.9rem" }}
        onHide={() => {
          setIsViewerOpen(false);
          setSelectedFileUrl(null);
        }}
        maximizable
        modal
        blockScroll
        // Change 2: Important! Remove padding and force height for the content area
        contentStyle={{
          padding: 0,
          height: "100%",
          width: "95%",
          overflow: "hidden",
          margin: "0px 31px",
        }}
        // Change 3: Optional - makes the dialog take up the whole screen immediately
        maximized={true}
      >
        {selectedFileUrl ? (
          <DocViewer
            documents={[{ uri: selectedFileUrl }]}
            pluginRenderers={DocViewerRenderers}
            style={{ height: "100%" }}
            config={{
              header: {
                disableHeader: true, // Hides the library's default header
              },
            }}
          />
        ) : (
          <ProgressSpinner />
        )}
      </Dialog>
    </div>
  );
};

export default ShowFilesRepo;
